import { createContext, useContext, useEffect, useReducer, useState } from "react";
import { cartReducer, productReducer } from "./Reducer";
import {db,storage} from '../firebaseConfig';
import {collection,query,onSnapshot,getDocs} from 'firebase/firestore'



const Cart = createContext();
const Context =  ({ children }) => {
  const productsInitial = []
  const [product, setProducts] = useState([]);
  

  const fetchAllProduct =async()=>{
    const productRef = collection(db, "Products");
    const data  = await getDocs(productRef);
    
    const products= data.docs.map((doc)=>({...doc.data(),id:doc.id}));
    setProducts(products)
  }

  const [state, dispatch] = useReducer(cartReducer, {
    // products: product,
    cart: [],
  });

  const [productState, productDispatch] = useReducer(productReducer, {
    
  });

  return (
    <Cart.Provider value={{ state, dispatch, productState, productDispatch,fetchAllProduct }}>
      {children}
    </Cart.Provider>
  );
};

export default Context;
export const CartState = () => {
  return useContext(Cart);
};
